import { FormattedMessage } from 'react-intl';
import { getAssetUrl } from '../../../utils/config';
import './style.scss';

const InformationBox = ({ text }: { text: string }) => (
  <div className="information-box">
    <img className="information-box__image" src={getAssetUrl('common/infoBlue.svg')} />
    <div className="information-box__text">
      <FormattedMessage id={text} />
    </div>
  </div>
);

export default InformationBox;
